import React, { useEffect } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { PainSections } from './components/PainSections';
import { SystemOverview } from './components/SystemOverview';
import { Modules } from './components/Modules';
import { LookInside } from './components/LookInside';
import { Bonuses } from './components/Bonuses';
import { NotAnEbook } from './components/NotAnEbook';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
interface AppProps {
  /** Show the rotating "just purchased" social-proof popup. */
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // Meta Pixel (hardened for sandboxed previews)
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '2208602033056253');
      (window as any).fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="35gm54lhq9kk">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2208602033056253&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="34x3flo0nh5h" />
      </noscript>

      <div className="min-h-screen w-full overflow-x-hidden bg-paper text-ink" data-id="element-2" data-mp="d2l6qzzotwz9">
        <main data-id="element-3" data-mp="86cnpbiddjmt">
          <Hero data-id="element-4" data-mp="83i1befspoqr" />
          <PainSections data-id="element-5" data-mp="3glea6jyr55fp" />
          <SystemOverview data-id="element-6" data-mp="3gklau424hi7l" />
          <Modules data-id="element-7" data-mp="3glwc9x83idvj" />
          <LookInside data-id="element-8" data-mp="3gja7u6gi4ehj" />
          <Bonuses data-id="element-9" data-mp="3bmbazg5gdtfn" />
          <NotAnEbook data-id="element-10" data-mp="3bn2xm1h2ogts" />
          <Offer data-id="element-11" data-mp="3bnmerfywf16r" />
          <Guarantee data-id="element-12" data-mp="3bo4lj6j6sxsx" />
          <Testimonials data-id="element-13" data-mp="3qb7j1d7if6g9" />
          <FAQ data-id="element-14" data-mp="3qbpq74vpn52y" />
          <FinalCTA data-id="element-15" data-mp="3qc95edtz7fda" />
        </main>
        <Footer data-id="element-16" data-mp="3qdaienujybxn" />
      </div>

      {showPurchasePopup && <PurchasePopup data-id="element-17" data-mp="3lk7ky4mnmic6" />}
    </>;
}